import { type TablePaginationProps, Divider, TablePagination } from '@mui/material';
import Text from '@mui/material/Typography';

import { Flex } from '../../flex';
import { createTheme } from '../theme';

interface DataGridFooterProps {
  total: number;
  pagination: TablePaginationProps;
}

function DataGridFooter(props: Readonly<DataGridFooterProps>) {
  const { total, pagination } = props;

  return (
    <>
      <Divider />
      <Flex
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          px: 2,
        }}
      >
        <Text color='secondary'>{total} รายการ</Text>
        <TablePagination component='div' {...pagination} />
      </Flex>
    </>
  );
}

const theme = createTheme({
  components: {
    MuiDataGrid: {
      defaultProps: {
        columnHeaderHeight: 48,
        rowHeight: 76,
        pageSizeOptions: [10, 20, 50, 100],
        autoHeight: true,
        hideFooterSelectedRowCount: true,
        slots: {
          footer: DataGridFooter,
        },
        slotProps: {
          footer: {
            total: 0,
            pagination: {
              count: 0,
              page: 0,
              onPageChange: () => console.log('onPageChange'),
              rowsPerPage: 10,
            },
          },
        },
      },
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({
            border: 'none',
            overflow: 'hidden',
            bgcolor: theme.palette.background.default,
            borderRadius: '8px',
            '& .MuiToolbar-root': {
              height: '64px',
            },
            '.MuiDataGrid-row:not(.MuiDataGrid-row--dynamicHeight)>.MuiDataGrid-cell': {
              whiteSpace: 'normal',
            },
          }),
        columnHeaders: ({ theme: { unstable_sx: sx, ...theme } }) =>
          sx({ bgcolor: theme.palette.grey[200] }),
        columnHeaderTitle: { fontSize: 16, fontWeight: 600 },
        columnHeader: ({ theme: { unstable_sx: sx } }) =>
          sx({
            py: 0,
            px: 2,
            ':focus-within': { outline: 'none' },
          }),
        columnHeaderTitleContainer: ({ theme: { unstable_sx: sx } }) => sx({ p: 0 }),
        columnHeaderCheckbox: ({ theme: { unstable_sx: sx } }) => sx({ p: 0 }),
        row: ({ theme: { unstable_sx: sx } }) =>
          sx({
            cursor: 'pointer',
            bgcolor: theme.palette.common.white,
            '&.Mui-selected': {
              bgcolor: 'primary.lighter',
            },
            '[data-field="actions"]': {
              cursor: 'default',
            },
          }),
        cell: ({ theme: { unstable_sx: sx } }) =>
          sx({
            fontSize: 16,
            p: 2,
            ':focus-within': { outline: 'none' },
          }),
      },
    },
  },
});

export default theme.components;
